const METADATA_LABEL_PATTERN = /\s+(?:slug|seo\s+title|meta\s+title|meta\s+description|focus\s+keyword|keywords?|tags?)\s*:\s*/i;

const stripHtml = (value = "") => {
  return String(value)
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, " ")
    .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, " ")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\s+/g, " ")
    .trim();
};

const removeSiteSuffix = (value = "") => {
  return String(value)
    .replace(/\s*[-–—|]\s*ResultWale\s*$/i, "")
    .trim();
};

export const hasSuspiciousPostTitle = (value = "") => {
  const raw = String(value || "");
  const cleaned = stripHtml(raw);

  return (
    /[\r\n]/.test(raw) ||
    /<[^>]+>/.test(raw) ||
    METADATA_LABEL_PATTERN.test(cleaned) ||
    cleaned.length > 180
  );
};

export const cleanPublicPostTitle = (
  value = "",
  { fallback = "Untitled update", maxLength = 160 } = {},
) => {
  let cleaned = stripHtml(value);

  if (!cleaned) {
    return fallback;
  }

  const metadataMatch = cleaned.match(METADATA_LABEL_PATTERN);

  if (metadataMatch?.index !== undefined && metadataMatch.index >= 20) {
    cleaned = cleaned.slice(0, metadataMatch.index).trim();
  }

  if (cleaned.length <= maxLength) {
    return cleaned;
  }

  const candidate = cleaned.slice(0, maxLength + 1);
  const lastSpace = candidate.lastIndexOf(" ");
  const cutAt = lastSpace >= Math.floor(maxLength * 0.7) ? lastSpace : maxLength;

  return `${cleaned.slice(0, cutAt).trim()}…`;
};

export const getPublicPostTitle = (
  post,
  { fallback = "Untitled update", maxLength = 160 } = {},
) => {
  const rawTitle = String(post?.title || "");

  if (hasSuspiciousPostTitle(rawTitle)) {
    const metaTitle = removeSiteSuffix(stripHtml(post?.metaTitle || ""));

    if (metaTitle && !hasSuspiciousPostTitle(metaTitle)) {
      return cleanPublicPostTitle(metaTitle, { fallback, maxLength });
    }
  }

  return cleanPublicPostTitle(rawTitle, { fallback, maxLength });
};

export default getPublicPostTitle;
